import { Link } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";
import { usePricing, planName } from "@/lib/pricing";

// AI and MCP connectors need the internal `growth` plan — shown to merchants as "Pro" once the new pricing is live.
function useAiPlanName() {
  const pricing = usePricing();
  return pricing?.final_active ? planName(pricing, "growth", "Pro") : "Growth";
}

export function AiUpgradeCta({ testid = "ai-upgrade-cta" }) {
  const plan = useAiPlanName();
  return (
    <div className="flex items-center gap-2 shrink-0" data-testid={testid}>
      <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-widest font-semibold text-slate-500">
        <Lock className="w-3 h-3" /> {plan} plan
      </span>
      <Link to="/merchant/billing" data-testid={`${testid}-link`}
            className="pf-btn-primary px-4 py-2 rounded-full text-xs font-semibold inline-flex items-center gap-1">
        Upgrade to {plan} <ArrowRight className="w-3 h-3" />
      </Link>
    </div>
  );
}

export function AiUpgradeCard({ feature = "This AI feature", testid = "ai-upgrade-card" }) {
  const plan = useAiPlanName();
  return (
    <div className="pf-card p-6 border-cyan-200 bg-gradient-to-br from-cyan-50 via-white to-white flex flex-wrap items-center gap-4 justify-between"
         data-testid={testid}>
      <div className="flex items-start gap-3 max-w-xl">
        <div className="w-10 h-10 rounded-full bg-slate-900 text-white flex items-center justify-center shrink-0">
          <Lock className="w-4 h-4" />
        </div>
        <div>
          <div className="font-display text-lg text-slate-900">Upgrade to unlock AI</div>
          <p className="text-sm text-slate-600 mt-0.5" data-testid={`${testid}-message`}>
            {feature} is a {plan} plan feature. Upgrade to {plan} or change your plan to use it.
          </p>
        </div>
      </div>
      <div className="flex items-center gap-3">
        <Link to="/merchant/billing" data-testid={`${testid}-upgrade`}
              className="pf-btn-primary px-5 py-2.5 rounded-full text-sm font-semibold inline-flex items-center gap-2">
          Upgrade to {plan} <ArrowRight className="w-4 h-4" />
        </Link>
        <Link to="/merchant/billing" data-testid={`${testid}-change-plan`}
              className="text-xs font-semibold text-slate-600 hover:text-slate-900 underline">
          Change plan
        </Link>
      </div>
    </div>
  );
}
